import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { http } from './api'
import { errorMessage } from './errors'
import type { NotificationPreferences, NotificationPreferencesInput } from './notification-types'

export interface NotificationApi {
  preferences(): Promise<NotificationPreferences>
  updatePreferences(input: NotificationPreferencesInput): Promise<NotificationPreferences>
}

class RealNotificationApi implements NotificationApi {
  preferences() {
    return http.get<NotificationPreferences>('/api/notifications/preferences')
  }

  updatePreferences(input: NotificationPreferencesInput) {
    return http.patch<NotificationPreferences>('/api/notifications/preferences', input)
  }
}

export const notificationApi: NotificationApi = new RealNotificationApi()

export const notificationKeys = {
  preferences: ['notifications', 'preferences'] as const,
}

export function useNotificationPreferences() {
  return useQuery({ queryKey: notificationKeys.preferences, queryFn: () => notificationApi.preferences() })
}

export function useUpdateNotificationPreferences() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (input: NotificationPreferencesInput) => notificationApi.updatePreferences(input),
    onSuccess: (data) => {
      queryClient.setQueryData(notificationKeys.preferences, data)
      toast.success('Meldingen opgeslagen')
    },
    onError: (e) => toast.error(errorMessage(e, 'Opslaan mislukt')),
  })
}
